import { scroll } from './locomotive';
import { closeMenu } from './handleMobileNav';

const selectors = {
  item: ".js-submenu-list a[href*='#']",
};

const handleNavigateHash = () => {
  const items = document.querySelectorAll(selectors.item);

  items.forEach((item) => {
    const { href, hash } = item;

    item.addEventListener('click', () => {
      setTimeout(() => {
        if (href !== window.location.href) return;

        scroll.scrollTo(hash);
        closeMenu();
      }, 0);
    });
  });
};
export default handleNavigateHash;
